import React from 'react'

import StampVideoChamada from '@/modern/components/Stamps/VideoChamada'
import {VideoChamada, MainInfo, Info, Button, IconVideo} from './style'
import {StampText, Description} from '../style'
import useModal from '@/modern/actions/useModal'

const TooltipVideoChamada = () => {
    const {openModal} = useModal('videoChamada')
    const dataTestLabel = 'tooltip_videochamada'
    const dataTestButton = 'button_videochamada'

    return (
        <VideoChamada>
            <StampVideoChamada daInfo/>
            <MainInfo data-test-component={dataTestLabel}>
                <Info>
                    <StampText>Videochamada</StampText>
                    <Description>Agende um horário para ver o carro em vídeo!</Description>
                </Info>
                <Button data-qa="btn_schedule_video_call" data-test-component={dataTestButton} onClick={openModal}>
                    Agendar videochamada
                    <IconVideo src="/assets/img/cam-video.svg"/>
                </Button>
            </MainInfo>
        </VideoChamada>
    )
}

export default TooltipVideoChamada
